// 🔐 KO'RINISH VA RUXSATLAR (admin → Foydalanuvchilar, backend services/uiAccess.js, docs/knowledge/208).
// Har foydalanuvchi uchun: Studio tablari, tepadagi tugmalar va panellar — ✅ To'liq / 👁 Faqat ko'rish / 🚫 Yopiq.
// Katalog serverdan (`GET /users/ui-catalog`) — kalitlar bitta joyda. O'zgarish darhol saqlanadi (`PUT /users/:id {ui_access}`).
// Server ham tekshiradi: yopilgan elementning ma'lumot yo'llari 403 (UI_FORBIDDEN); «faqat ko'rish» — yozish rad.
import React, { useEffect, useMemo, useState } from 'react';

let _catalogP = null;   // katalog bir marta olinadi (bir nechta foydalanuvchi kartasi bir xil so'rov yubormasin)

const MODES = [
  ['full', "To'liq", 'bg-emerald-600 text-white'],
  ['view', "Faqat ko'rish", 'bg-sky-600 text-white'],
  ['hide', 'Yopiq', 'bg-rose-600 text-white'],
];
// Tayyor andozalar — bitta bosishda; keyin har birini alohida o'zgartirsa bo'ladi.
const PRESETS = [
  {
    key: 'client', label: '🤝 Mijoz uchun',
    hint: "Buyurtmachi: xarita, sinov topilmalari, hujjatlar (faqat ko'rish), crashlar; kod, baza, server, jarayonlar va Agent yopiq",
    value: {
      'nav.waiting': 'hide', 'nav.processes': 'hide', 'nav.agent': 'hide', 'nav.tokens': 'hide',
      'studio.browser': 'hide', 'studio.emulator': 'hide', 'studio.database': 'hide', 'studio.files': 'hide',
      'studio.status': 'hide', 'studio.architecture': 'hide', 'studio.todo': 'hide', 'studio.publish': 'hide',
      'studio.secrets': 'hide', 'studio.security': 'hide', 'studio.team': 'hide', 'studio.engine_panel': 'hide',
      'studio.docs': 'view', 'studio.qa': 'view', 'studio.crashes': 'view',
    },
  },
  { key: 'all', label: '♻️ Hammasini ochish', hint: 'Barcha elementlar to\'liq ochiq', value: {} },
];

export default function UiAccessEditor({ user, authFetch, apiUrl, toast, onSaved }) {
  const [cat, setCat] = useState(null);
  const [err, setErr] = useState('');
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [acc, setAcc] = useState(() => ({ ...(user.ui_access || {}) }));
  useEffect(() => { setAcc({ ...(user.ui_access || {}) }); }, [user.id, JSON.stringify(user.ui_access || {})]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!open || cat) return;
    if (!_catalogP) {
      _catalogP = authFetch(`${apiUrl}/users/ui-catalog`).then(r => (r.ok ? r.json() : Promise.reject(new Error('Katalog yuklanmadi'))))
        .catch(e => { _catalogP = null; throw e; });
    }
    _catalogP.then(setCat).catch(e => setErr(e.message));
  }, [open, cat, authFetch, apiUrl]);

  const counts = useMemo(() => {
    const v = Object.values(acc);
    return { hide: v.filter(x => x === 'hide').length, view: v.filter(x => x === 'view').length };
  }, [acc]);

  const save = async (next) => {
    const prev = acc;
    setAcc(next); setBusy(true);
    try {
      const r = await authFetch(`${apiUrl}/users/${user.id}`, {
        method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ ui_access: next }),
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(d.error || 'Saqlanmadi');
      if (onSaved) onSaved();
    } catch (e) {
      setAcc(prev);
      if (toast) toast.error(e.message); else alert(e.message);
    } finally { setBusy(false); }
  };
  const setMode = (key, mode) => {
    const next = { ...acc };
    if (mode === 'full') delete next[key]; else next[key] = mode;
    save(next);
  };

  return (
    <div className="mt-3 pt-3 border-t border-gray-100 dark:border-gray-700">
      <button type="button" onClick={() => setOpen(o => !o)}
        className="w-full flex items-center gap-2 text-left text-xs font-semibold text-gray-500 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200">
        <span>{open ? '▼' : '▶'}</span>
        <span>🔐 Ko'rinish va ruxsatlar</span>
        <span className="font-normal">
          {counts.hide || counts.view
            ? `— ${counts.hide ? `${counts.hide} ta yopiq` : ''}${counts.hide && counts.view ? ', ' : ''}${counts.view ? `${counts.view} ta faqat ko'rish` : ''}`
            : "— hammasi ochiq"}
        </span>
      </button>
      {open && (
        <div className="mt-2 space-y-3">
          <p className="text-xs text-gray-500 dark:text-gray-400">
            Studio tablari, tepadagi tugmalar va panellarni shu foydalanuvchiga ochish, «faqat ko'rish» qilish yoki yopish.
            Server ham shunga amal qiladi: yopilgan bo'lim ma'lumoti unga berilmaydi. O'zgarish foydalanuvchi sahifani yangilaganda kuchga kiradi.
            Chap menyudagi bo'limlar — yuqoridagi «Bo'limlarga ruxsat»da.
          </p>
          <div className="flex flex-wrap gap-2">
            {PRESETS.map(p => (
              <button key={p.key} type="button" disabled={busy} title={p.hint}
                onClick={() => { if (window.confirm(`«${p.label}» andozasi qo'llansinmi? Hozirgi sozlamalar almashtiriladi.`)) save({ ...p.value }); }}
                className="text-xs px-3 py-1.5 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-50">
                {p.label}
              </button>
            ))}
          </div>
          {err && <div className="text-xs text-rose-600">{err}</div>}
          {!cat && !err && <div className="text-xs text-gray-500">Yuklanmoqda…</div>}
          {cat && cat.groups.map(g => (
            <div key={g.key}>
              <div className="text-[11px] font-semibold uppercase tracking-wide text-gray-400 mb-1">{g.label}</div>
              <div className="rounded-lg border border-gray-200 dark:border-gray-700 divide-y divide-gray-100 dark:divide-gray-700">
                {cat.items.filter(it => it.group === g.key).map(it => {
                  const cur = acc[it.key] || 'full';
                  return (
                    <div key={it.key} className="flex flex-wrap items-center gap-2 px-3 py-1.5">
                      <div className="flex-1 min-w-[12rem]">
                        <div className="text-sm text-gray-800 dark:text-gray-100">{it.label}</div>
                        {it.hint && <div className="text-[11px] text-gray-500 dark:text-gray-400">{it.hint}</div>}
                      </div>
                      <div className="inline-flex rounded-lg overflow-hidden border border-gray-200 dark:border-gray-700" role="radiogroup" aria-label={it.label}>
                        {MODES.filter(([m]) => m !== 'view' || it.view).map(([m, label, onCls]) => (
                          <button key={m} type="button" role="radio" aria-checked={cur === m} disabled={busy || cur === m}
                            onClick={() => setMode(it.key, m)}
                            className={`text-xs px-2.5 py-1 border-l border-gray-200 dark:border-gray-700 first:border-l-0 transition disabled:cursor-default ${cur === m ? `${onCls} font-semibold` : 'bg-white dark:bg-gray-800 text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700'}`}>
                            {label}
                          </button>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
